<template>
  <v-btn small flat outline color="pipefishOrange" @click="$emit('edit')">Edit</v-btn>
</template>

<script>
export default {
}
</script>

<style>

</style>
